export const isNil = (val: unknown): val is null | undefined => val == null;

export const isEmptyString = (val: unknown): boolean =>
  typeof val === "string" && val.trim().length === 0;

export const isBlank = (val: unknown): boolean =>
  isNil(val) || isEmptyString(val);

export const hasValue = (val: unknown): boolean => !isBlank(val);

export const isNotEmptyArray = <T>(val: T[] | unknown): val is T[] =>
  Array.isArray(val) && val.length > 0;

export const isEmptyObject = (val: unknown): boolean =>
  val !== null && typeof val === "object" && !Array.isArray(val) && Object.keys(val).length === 0;